export default "__VITE_ASSET__Cvo7UQdf__"